var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
var cls = classNames('slice-feature-tout');
import { first } from 'lodash';
import { classNames } from '../../utils/cn';
import { ContentEntityContent } from './content-entity-content';
import { ImageEntity } from './image-entity';
import { useEntity } from '../../hooks/use-entity';
export var SliceFeatureToutDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding: ", " ", " ", " ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding: ", " ", " ", " ", ";\n  "])), theme.UNIT(2), theme.UNIT(4), theme.UNIT(6), theme.UNIT(4)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "]))),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme.UNIT(8), theme.UNIT(0), theme.UNIT(8))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1em;\n    color: inherit;\n    flex-basis: 50%;\n    h2, h3 {\n      color: inherit;\n    }\n\n    ul {\n      margin-left: 0;\n      padding-left: 8px;\n\n      li {\n        margin-bottom: 0.5em;\n        &::before {\n          color: #FFF;\n          font-size: 0.75em;\n        }\n      }\n    }\n\n  "], ["\n    font-size: 1em;\n    color: inherit;\n    flex-basis: 50%;\n    h2, h3 {\n      color: inherit;\n    }\n\n    ul {\n      margin-left: 0;\n      padding-left: 8px;\n\n      li {\n        margin-bottom: 0.5em;\n        &::before {\n          color: #FFF;\n          font-size: 0.75em;\n        }\n      }\n    }\n\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 320px;\n  "], ["\n    width: 320px;\n  "])))
});
var ImageContainerStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    order: 0;\n    display: flex;\n    justify-content: flex-end;\n  "], ["\n    order: 0;\n    display: flex;\n    justify-content: flex-end;\n  "]))),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-basis: 50%; \n    order: 1;\n  "], ["\n    flex-basis: 50%; \n    order: 1;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(ContentEntityContent)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  ImageContainer: styled.div.attrs(cls.attr('image-container'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  Image: styled(ImageEntity)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var SliceFeatureTout = function SliceFeatureTout(props) {
  var className = props.className,
      children = props.children;
  var entity = useEntity(props.entity);
  var images = entity.images,
      content = entity.content;
  var image = first(images);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Content, {
    entity: entity
  }), image && React.createElement(My.ImageContainer, null, React.createElement(My.Image, {
    entity: image
  })));
};
SliceFeatureTout.defaultProps = SliceFeatureToutDefaultProps;
SliceFeatureTout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;